// Navigation translations
const navigationTranslations = {
    brand_list: {
        th: "รายชื่อแบรนด์",
        en: "Brands",
        ja: "ブランド一覧",
    },
    product_list: {
        th: "รายการสินค้า",
        en: "Products",
        ja: "商品一覧",
    },
    rankings: {
        th: "อันดับ",
        en: "Rankings",
        ja: "ランキング",
    },
    board_default: {
        th: "กระดานสนทนา",
        en: "Discussion",
        ja: "掲示板",
    },
    board_scoop: {
        th: "กระดานสนทนา",
        en: "Scoop",
        ja: "スクープ",
    },
    board_review: {
        th: "รีวิว",
        en: "Review",
        ja: "レビュー",
    },
    board_user_reviews: {
        th: "รีวิวโดยผู้ใช้",
        en: "User Reviews",
        ja: "ユーザーレビュー",
    },
    board_beauty_news: {
        th: "ข่าวความงาม",
        en: "Beauty News",
        ja: "ビューティーニュース",
    },
    board_editorial_reviews: {
        th: "รีวิวจากกองบรรณาธิการ",
        en: "Editorial Reviews",
        ja: "編集部レビュー",
    },
    board_expert_reviews: {
        th: "รีวิวโดยผู้เชี่ยวชาญ",
        en: "Expert Reviews",
        ja: "専門家レビュー",
    },
    home: {
        th: "หน้าแรก",
        en: "Home",
        ja: "ホーム",
    },
    board_articles: {
        th: "บทความ",
        en: "Articles",
        ja: "記事",
    },
    board_activities: {
        th: "กิจกรรม",
        en: "Activities",
        ja: "アクティビティ",
    },
    user_list: {
        th: "สมาชิกชุมชนความงาม",
        en: "Beauty Community Members",
        ja: "美容コミュニティメンバー",
    },
    view_profile: {
        th: "ดูโปรไฟล์",
        en: "View profile",
        ja: "プロフィールを見る",
    },
    vanilla_login: {
        th: "เข้าสู่ระบบ",
        en: "Login",
        ja: "ログイン",
    },
    register: {
        th: "สมัครสมาชิก",
        en: "Register",
        ja: "新規登録",
    },
    register_free_cta: {
        th: "สมัครสมาชิกฟรีที่นี่",
        en: "Register for free",
        ja: "無料会員登録はこちら",
    },
    page_navigation: {
        th: "การนำทางหน้า",
        en: "Page navigation",
        ja: "ページナビゲーション",
    },
    footer_about: {
        th: "เกี่ยวกับ Vanilla",
        en: "About Vanilla",
        ja: "Vanilla について",
    },
    footer_guidelines: {
        th: "แนวทางการรีวิว",
        en: "Review Guidelines",
        ja: "レビューガイドライン",
    },
    footer_terms: {
        th: "เงื่อนไขการใช้งาน",
        en: "Terms of Use",
        ja: "利用規約",
    },
    footer_privacy: {
        th: "นโยบายความเป็นส่วนตัว",
        en: "Privacy Policy",
        ja: "プライバシーポリシー",
    },
    footer_contact: {
        th: "ติดต่อเรา",
        en: "Contact Us",
        ja: "お問い合わせ",
    },
    footer_site_name: {
        th: "เว็บรีวิวเครื่องสำอาง VANILLA",
        en: "VANILLA Beauty Review",
        ja: "コスメレビューサイト VANILLA",
    },
    footer_description: {
        th: "คือเว็บรีวิวเครื่องสำอางจากผู้ใช้จริงที่ใหญ่ที่สุดในประเทศไทย",
        en: "Thailand's largest real-user cosmetics review platform.",
        ja: "タイ最大の実ユーザーによるコスメレビューサイトです。",
    },
    hero_cta: {
        th: "ค้นหาผลิตภัณฑ์",
        en: "Find Products",
        ja: "製品を探す",
    },
    hero_description: {
        th: "ร่วมพูดคุย ถามตอบ\nและแบ่งปันประสบการณ์ด้านสกินแคร์และเมคอัพ",
        en: "Join discussions, ask questions,\nand share your skincare or makeup experiences.",
        ja: "スキンケアやメイクの体験を話し合い、質問し合い、\n何千人もの実ユーザーと共有しましょう。",
    },
    page_hero_title_brands: {
        th: "ค้นพบแบรนด์ความงามที่คุณชื่นชอบ",
        en: "Discover Your Favourite Beauty Brands",
        ja: "お気に入りのビューティーブランドを見つけよう",
    },
    page_hero_subtitle_brands: {
        th: "ร่วมค้นหา รีวิว และแบ่งปันความคิดเห็นเกี่ยวกับแบรนด์เครื่องสำอางจากทั่วโลก",
        en: "Explore, review, and share opinions on cosmetic brands from around the world.",
        ja: "世界中のコスメブランドを探索し、レビューし、意見を共有しよう。",
    },
    page_hero_cta_brands: {
        th: "ดูแบรนด์ทั้งหมด",
        en: "Browse All Brands",
        ja: "すべてのブランドを見る",
    },
    page_hero_title_rankings: {
        th: "จัดอันดับ",
        en: "Rankings",
        ja: "ランキング",
    },
    page_hero_subtitle_rankings: {
        th: "ผลิตภัณฑ์และสมาชิกยอดนิยมประจำเดือน คัดสรรจากรีวิวจริงของชุมชน VANILLA",
        en: "Monthly top products and members, curated from real reviews by the VANILLA community.",
        ja: "VANILLAコミュニティの実レビューから厳選した月間人気商品・メンバー。",
    },
    page_hero_title_about: {
        th: "เกี่ยวกับเรา",
        en: "About Us",
        ja: "私たちについて",
    },
    page_hero_subtitle_about: {
        th: "VANILLA คือชุมชนรีวิวเครื่องสำอางจากผู้ใช้จริงที่ใหญ่ที่สุดในประเทศไทย",
        en: "VANILLA is Thailand's largest real-user cosmetics review community.",
        ja: "VANILLAはタイ最大の実ユーザーによるコスメレビューコミュニティです。",
    },
    page_hero_title_articles: {
        th: "บทความ ความงาม & เรื่องราวจริง",
        en: "Beauty Insights, Reviews & Real Stories",
        ja: "ビューティー記事・レビュー・リアルストーリー",
    },
    page_hero_subtitle_articles: {
        th: "ค้นพบบทความคัดสรร เคล็ดลับจากชุมชน และเรื่องราวความงามที่กำลังมาแรง",
        en: "Discover editor-curated articles, community tips, and trending beauty stories.",
        ja: "編集部厳選の記事、コミュニティのヒント、トレンドのビューティーストーリーを見つけよう。",
    },
    page_hero_cta_articles: {
        th: "ดูบทความทั้งหมด",
        en: "Browse Articles",
        ja: "すべての記事を見る",
    },
    page_hero_title_activities: {
        th: "เข้าร่วมกิจกรรม & รับรางวัล",
        en: "Join Activities & Earn Rewards",
        ja: "アクティビティに参加してポイントをゲット",
    },
    page_hero_subtitle_activities: {
        th: "เข้าร่วมแคมเปญ ทดลองผลิตภัณฑ์ และอีเวนต์ชุมชน — เปิดรับสำหรับสมาชิก VANILLA ทุกคน",
        en: "Participate in exclusive sampling campaigns, product trials, and community events — open to all Vanilla members.",
        ja: "限定サンプリングキャンペーン、製品トライアル、コミュニティイベントに参加しよう。",
    },
    page_hero_cta_activities: {
        th: "ดูกิจกรรมทั้งหมด",
        en: "See Current Activities",
        ja: "アクティビティを見る",
    },
    page_hero_title_mypage: {
        th: "ข้อมูลผู้ใช้",
        en: "User Information",
        ja: "ユーザー情報",
    },
    page_hero_subtitle_mypage: {
        th: "ข้อมูลรายละเอียดเกี่ยวกับผู้ใช้",
        en: "Detailed information about the user",
        ja: "ユーザーに関する詳細情報",
    },
    products: {
        th: "สินค้า",
        en: "Products",
        ja: "製品",
    },
    members: {
        th: "สมาชิก",
        en: "Members",
        ja: "メンバー",
    },
    view_all: {
        th: "ดูทั้งหมด",
        en: "View all",
        ja: "すべて見る",
    },
    new_reviews: {
        th: "รีวิวใหม่",
        en: "New Reviews",
        ja: "新着レビュー",
    },
    new_reviews_subtitle: {
        th: "รีวิวใหม่ล่าสุดจากสมาชิกชุมชน Vanilla",
        en: "The latest reviews from the Vanilla community",
        ja: "Vanillaコミュニティの最新レビュー",
    },
    product_rankings: {
        th: "อันดับสินค้า",
        en: "Product Rankings",
        ja: "商品ランキング",
    },
    product_rankings_subtitle: {
        th: "อันดับสินค้าความงามยอดนิยมประจำเดือน คัดจากรีวิวจริงของชุมชน",
        en: "Monthly top beauty products, ranked by real community reviews",
        ja: "コミュニティの実レビューから選ぶ月間人気コスメランキング",
    },
    user_rankings: {
        th: "อันดับผู้ใช้",
        en: "User Rankings",
        ja: "ユーザーランキング",
    },
    user_rankings_subtitle: {
        th: "นักรีวิวที่มีคะแนนสูงสุดและมีส่วนร่วมมากที่สุดในชุมชนประจำเดือน",
        en: "Top-scoring and most active reviewers in the community this month",
        ja: "今月のコミュニティで最も活躍したハイスコアレビュワー",
    },
    recommended_reviews: {
        th: "รีวิวแนะนำ",
        en: "Recommended Reviews",
        ja: "おすすめレビュー",
    },
    reviews_from_vanilla: {
        th: "คัดสรรจาก Vanilla",
        en: "Picks from Vanilla",
        ja: "Vanillaのおすすめ",
    },
    reviews_from_vanilla_subtitle: {
        th: "รีวิวจริงจากสมาชิกชุมชน Vanilla คัดสรรโดยทีมงาน",
        en: "Hand-picked real reviews from the Vanilla community",
        ja: "Vanillaスタッフが厳選したコミュニティの実レビュー",
    },
    recommended_users: {
        th: "ผู้ใช้แนะนำ",
        en: "Recommended Users",
        ja: "おすすめユーザー",
    },
    top_members: {
        th: "สมาชิกยอดเยี่ยม",
        en: "Top Members",
        ja: "トップメンバー",
    },
    top_members_subtitle: {
        th: "สมาชิกที่แอคทีฟและมีอิทธิพลมากที่สุดในชุมชนความงาม Vanilla",
        en: "The most active and influential members of the Vanilla beauty community",
        ja: "Vanilla美容コミュニティで最も活躍する影響力のあるメンバー",
    },
    articles: {
        th: "บทความ",
        en: "Articles",
        ja: "記事",
    },
    articles_beauty_news: {
        th: "บทความ [ข่าวความงาม]",
        en: "Articles [Beauty News]",
        ja: "記事【ビューティーニュース】",
    },
    articles_editorial_reviews: {
        th: "บทความ [บทวิจารณ์จากบรรณาธิการ]",
        en: "Articles [Editorial Reviews]",
        ja: "記事【編集者レビュー】",
    },
    articles_expert_reviews: {
        th: "บทความ (รีวิวจากผู้เชี่ยวชาญ)",
        en: "Articles (Expert Reviews)",
        ja: "記事（専門家レビュー）",
    },
    articles_subtitle: {
        th: "บทความความงามล่าสุด เทคนิค และเทรนด์จากทีมบรรณาธิการ Vanilla",
        en: "The latest beauty articles, tips, and trends from the Vanilla editorial team",
        ja: "Vanilla編集チームによる最新の美容記事・テクニック・トレンド",
    },
    review_awards: {
        th: "รางวัลรีวิว",
        en: "Review Awards",
        ja: "レビューアワード",
    },
    review_awards_subtitle: {
        th: "ผลิตภัณฑ์ที่ได้รับรีวิวมากที่สุดจากชาว Vanilla",
        en: "Products with the most reviews from the Vanilla community",
        ja: "Vanillaコミュニティで最もレビューされた商品",
    },
};

export { navigationTranslations };
